<template>
  <component :is="baseComponent"
             :to="link.path ? link.path : '/'"
             :class="{active: isActive}"
             tag="li">
    <a v-if="isMenu"
       data-toggle="collapse"
       href="javascript:void(0)"
       class="sidebar-links-top1"
       @click="CollapseMenu()">
      <i :class="link.icon"></i>
      <p>
        <!-- izpis očetov -->
        <span v-if="link.name.length > 18">
          {{ link.name.split(' ')[0] }}
            <span class="nova-vrstica oce">
              {{ link.name.split(' ')[1] }}
            </span>
          </span>
        <span v-else>
          {{ link.name }}
          </span>
        <b class="caret"></b>
      </p>
    </a>
    <div v-if="$slots.default || this.isMenu">
      <el-collapse-transition accordion="true">
        <ul class="nav ul-dp" v-show="!link.collapsed">
          <slot></slot>
        </ul>
      </el-collapse-transition>
    </div>
    <slot name="title" v-if="children.length === 0 && !$slots.default && link.path">
      <component
        :to="link.path"
        :is="ElementType(link, false)"
        :class="{active: link.active}"
        :target="link.target"
        :href="link.path">
        <template v-if="addLink">
          <span class="sidebar-mini">&nbsp;</span>
          <!-- izpis otrok -->
          <span class="sidebar-normal children" @click="menia">
            <span v-if="link.name.length > 24">
            {{ link.name.split('in')[0] }}
              <span class="nova-vrstica otrok">
                in {{ link.name.split('in')[1] }}
              </span>
            </span>
            <span v-else>
              {{ link.name }}
            </span>
          </span>
        </template>
        <template v-else>
          <i :class="link.icon"></i>
          <p @click="CollapseMenu(true)">{{ link.name }}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import Vue from 'vue'

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition
  },
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: '',
          path: '',
          children: []
        }
      }
    }
  },
  provide () {
    return {
      addLink: this.AddChild,
      removeLink: this.removeChild
    }
  },
  inject: {
    addLink: {default: null},
    removeLink: {default: null}
  },
  data () {
    return {
      izbranNadmeni: '',
      children: []
    }
  },
  computed: {
    baseComponent () {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link'
    },
    isMenu () {
      return this.children.length > 0 || this.menu === true
    },
    isActive () {
      if (this.$route) {
        let matchingRoute = this.children
          .find((c) => this.$route.path.startsWith(c.link.path))
        if (matchingRoute !== undefined) {
          this.link.collapsed = false
          return true
        }
      }
      return false
    }
  },
  methods: {
    menia () {
      this.$parent.$parent.$emit('zapiranjeMenija')
    },
    AddChild (item) {
      const index = this.$slots.default.indexOf(item.$vnode)
      this.children.splice(index, 0, item)
    },
    removeChild (item) {
      const tabs = this.children
      const index = tabs.indexOf(item)
      tabs.splice(index, 1)
    },
    ElementType (link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? 'li' : 'a'
      } else {
        return 'router-link'
      }
    },
    GetId () {
      return this._uid
    },
    LinkAbbreviation (name) {
      const matches = name.match(/\b(\w)/g)
      return matches.join('')
    },
    Wait (ms) {
      var start = new Date().getTime()
      var end = start
      while (end < start + ms) {
        end = new Date().getTime()
      }
    },
    CollapseMenu (link = false) {
      this.link.collapsed = !this.link.collapsed
      for (let i = 0; i < this.$sidebar.sidebarLinks.length; i++) {
        if (i !== this.$attrs.parentId) {
          Vue.set(this.$sidebar.sidebarLinks[i], 'collapsed', true)
        } else {
          Vue.set(this.$sidebar.sidebarLinks[i], 'collapsed', this.link.collapsed)
        }
        if (link) {
          this.$parent.$emit('zapiranjeMenija')
        }
      }
    }
  },
  mounted () {
    if (this.addLink) {
      this.addLink(this)
    }
    if (this.link.collapsed === 'undefined') {
      this.link.collapsed = true
    }
    if (this.isActive && this.isMenu) {
      this.link.collapsed = false
    }
  },
  destroyed () {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
    if (this.removeLink) {
      this.removeLink(this)
    }
  }
}
</script>
<style scoped>
@import '../../../../static/css/t2-icons.css';
</style>

<style scoped>
.sidebar .sidebar-wrapper > .nav i {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SidebarItem.vue